import { useState, useEffect } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';

import { useToast } from './toast';

export default function AddToCart({ nonce, productId }) {
  const [cart, setCart] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const { toast } = useToast();

  const isProductInCart = cart?.items?.some((item) => item.id === parseInt(productId));

  useEffect(() => {
    fetchCart();
  }, []);

  useEffect(() => {
    const onAddToCart = () => {
      fetchCart();
    }

    window.addEventListener('add-to-cart', onAddToCart);

    return () => {
      window.removeEventListener('add-to-cart', onAddToCart);
    }
  }, [])

  useEffect(() => {
    if (isProductInCart) {
      setQuantity(cart.items.find((item) => item.id === parseInt(productId)).quantity);
    }
  }, [cart]);

  const fetchCart = async () => {
    const response = await apiFetch({
      path: '/wc/store/v1/cart',
    });

    setCart(response);
  }

  const handleAddToCart = async () => {
    const result = await apiFetch({
      path: `wc/store/v1/cart/add-item?id=${productId}&quantity=${quantity}`,
      method: 'POST',
      headers: {
        'Nonce': nonce,
      },
    });

    setCart(result);

    notifyCartUpdate();

    toast({
      title: 'Successfully added to cart',
      status: 'success',
    });
  }

  const handleUpdateCartQuantity = async () => {
    const key = cart.items.find((item) => item.id === parseInt(productId)).key;

    const response = await apiFetch({
      path: `/wc/store/v1/cart/update-item?key=${key}&quantity=${quantity}`,
      method: 'POST',
      headers: {
        'Nonce': nonce,
      },
    })

    setCart(response);

    notifyCartUpdate();

    toast({
      title: 'Cart updated successfully',
      status: 'success',
    });
  }

  const notifyCartUpdate = () => {
    window.dispatchEvent(new CustomEvent('add-to-cart'));
  }

  return (
    <div className="mb-16 flex items-center gap-x-6">
      <select
        class="border border-gray-300 rounded-md px-2 py-2 w-32 text-center block"
        value={quantity}
        onChange={(e) => setQuantity(e.target.value)}
      >
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
        <option value="6">6</option>
        <option value="7">7</option>
        <option value="8">8</option>
      </select>
      <button
        class="bg-black hover:bg-[#bb9e40] duration-300 text-white px-6 py-2 rounded block text-sm"
        onClick={isProductInCart ? handleUpdateCartQuantity : handleAddToCart}
      >
        Add to Cart
      </button>
    </div>
  )
}
